import { h } from "hyperapp";
import actionOnSelectedCSS from "./actions-on-seleted.css";

export const actionsOnSelected = ({
  translations,
  section,
  state,
  onScheduleModalClosed = () => true,
}) => {
  return (
    <form>
      <div class="align-items-center justify-content-center form-row">
        <div class="d-flex align-items-center col-sm-auto text-center">
          {state[section].selected.length === 0 && (
            <span class={actionOnSelectedCSS["noPlaceSelected"]}>
              {translations["noPlacesSelected"]}
            </span>
          )}
          {state[section].selected.length === 1 && (
            <span class="align-text-bottom">
              <b>1</b> Local selecionado
            </span>
          )}
          {state[section].selected.length > 1 && (
            <span class="align-text-bottom">
              <b>{state[section].selected.length}</b>{" "}
              {translations["selectedPlaces"]}
            </span>
          )}
        </div>
        <div class="col-12 col-md-auto">
          <div class="btn-block btn-group">
            <button
              style="width:114px;"
              aria-expanded="false"
              aria-haspopup="true"
              class="btn btn-outline-secondary dropdown-toggle"
              data-toggle="dropdown"
              disabled={state[section].selected.length === 0}
              type="button"
            >
              {translations["actions"]}
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button
                class="dropdown-item"
                onclick={() => {
                  function handleResponse(event) {
                    const { data } = event;
                    if (data.event === "modal-closed") {
                      window.removeEventListener("message", handleResponse);
                      onScheduleModalClosed();
                    }
                  }
                  window.addEventListener("message", handleResponse);
                  window.parent.postMessage(
                    {
                      id: "54272daa-87af-4992-bd86-c2bcfad91501",
                      places: state[section].selected.map(item => ({
                        ...item,
                        location: item.location
                          ? {
                              latitude: item.location.x,
                              longitude: item.location.y,
                            }
                          : null,
                      })),
                    },
                    "*",
                  );
                }}
                type="button"
              >
                {translations["prepareSchedule"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};
